import React, { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"

import Panel from "shared/components/Panel"

import Step from "./components/Step"

import styles from "./DeliveryProgress.css"

class DeliveryProgress extends Component {
  static propTypes = {
    status: PropTypes.string,
    deliveryDays: PropTypes.object,
    deliveryDates: PropTypes.object,
    orderDate: PropTypes.string.isRequired,
  }
  static defaultProps = {
    status: "",
    deliveryDays: {},
    deliveryDates: {},
  }
  constructor(props) {
    super(props)

    this.state = {
      statuses: [
        { name: "ORDER_PLACED", displayName: "ORDERED", additionalInformation: null, passed: true },
        { name: "RECEIVED_AT_HUB", displayName: "INTERNATIONAL DISPATCH", additionalInformation: null, passed: false },
        { name: "INTERNATIONAL_TRANSIT", displayName: "IN TRANSIT", additionalInformation: null, passed: false },
        { name: "DELIVERED", displayName: "DELIVERED", additionalInformation: null, passed: false },
      ],
    }
  }

  componentWillMount() {
    this.setStatuses()
  }

  setStatuses() {
    const { status } = this.props
    const { statuses } = this.state
    let passedCurrent = false

    const newStatuses = statuses.map(state => {
      let passed = false
      if (!passedCurrent) {
        passed = true
        if (state.name === status) {
          passedCurrent = true
        }
      }

      const displayName = this.getDisplayName(state.displayName, passed)

      return {
        ...state,
        passed,
        displayName,
        additionalInformation: this.getAdditionalInformation(displayName, passed),
      }
    })

    this.setState({
      statuses: newStatuses,
    })
  }

  getDisplayName(displayName, passed) {
    if (this.isEstimatedDeliveryPassed(displayName, passed)) {
      return "ESTIMATED DELIVERY"
    }
    return displayName
  }

  getAdditionalInformation(displayName) {
    if (displayName === "ORDERED") {
      return this.getOrderedDate()
    }
    if (displayName === "ESTIMATED DELIVERY") {
      return this.getEstimatedDelivery()
    }
    return null
  }

  getOrderedDate() {
    const { orderDate } = this.props
    const date = orderDate ? (moment(orderDate).format("D MMM YYYY")).toUpperCase() : null
    return date && <span className={styles.displayName}>{date}</span>
  }

  getEstimatedDelivery() {
    const { deliveryDays, deliveryDates } = this.props
    if (!deliveryDates) {
      return (
        <span className={styles.additionalInformation}>
          {deliveryDays.from_days} - {deliveryDays.to_days} business days
        </span>
      )
    }
    let dateFrom = moment(deliveryDates.from_date).format("D MMM YYYY").toUpperCase()
    const dateTo = moment(deliveryDates.to_date).format("D MMM YYYY").toUpperCase()
    const dateFromYear = moment(dateFrom).format("YYYY")
    const dateToYear = moment(dateTo).format("YYYY")
    if (dateFromYear === dateToYear) {
      dateFrom = moment(deliveryDates.from_date).format("D MMM").toUpperCase()
    }
    return <span className={styles.additionalInformation}>{dateFrom} - {dateTo}</span>
  }

  isEstimatedDeliveryPassed(displayName, passed) {
    const { deliveryDays, deliveryDates } = this.props

    return displayName === "DELIVERED" &&
      !passed &&
      ((deliveryDays && deliveryDays.from_days && deliveryDays.to_days) ||
      (deliveryDates && deliveryDates.from_date && deliveryDates.to_date))
  }

  addDeliveryMidstep(step) {
    const { orderDate } = this.props
    const orderedTime = moment(orderDate)
    const currentTime = moment()
    const hoursSinceOrdered = currentTime.diff(orderedTime, "hours")
    return step.name === "RECEIVED_AT_HUB" && hoursSinceOrdered >= 36 && !step.passed
  }

  render() {
    const { statuses } = this.state

    return (
      <Panel className="m-b-20">
        <div className={styles.root}>
          {statuses.map((step, index) => (
            <Step
              key={step.name}
              step={step}
              showDivider={index > 0}
              showDividerMidStep={this.addDeliveryMidstep(step)}
            />
          ))}
        </div>
      </Panel>
    )
  }
}

export default DeliveryProgress



// WEBPACK FOOTER //
// ./src/views/Parcel/components/DeliveryProgress/DeliveryProgress.js